"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var Modal = /** @class */ (function () {
    function Modal(contentId, fallbackText) {
        this.fallbackText = fallbackText;
        this.contentTemplateEl = document.getElementById(contentId);
        this.modalTemplateEl = document.getElementById('modal-template');
    }
    Modal.prototype.show = function () {
        if ('content' in document.createElement('template')) {
            var modalElements = document.importNode(this.modalTemplateEl.content, true);
            this.modalElement = modalElements.querySelector('.modal');
            this.backdropElement = modalElements.querySelector('.backdrop');
            var contentElement = document.importNode(this.contentTemplateEl.content, true);
            this.modalElement.appendChild(contentElement);
            document.body.insertAdjacentElement('afterbegin', this.modalElement);
            document.body.insertAdjacentElement('afterbegin', this.backdropElement);
        }
        else {
            // fallback code
            alert(this.fallbackText);
        }
    };
    Modal.prototype.hide = function () {
        if (this.modalElement) {
            this.modalElement.remove();
            this.backdropElement.remove();
            this.modalElement = null;
            this.backdropElement = null;
        }
    };
    return Modal;
}());
exports.Modal = Modal;
